<template>
  <div class="rounded px-5 bg-white">
    <pt-loader v-if="isLoading" icon-class="fa-refresh fa-5x text-white" container="body" />
    <div v-if="!isLoading && approvalList.length">
      <div class="flex flex-col bg-grey-lighter">
        <div v-for="(approval, index) in approvalList" :key="index">
          <approval-item :item="approval" class="border-b" @showDetail="showDetail" />
        </div>
      </div>
      <approval-changes ref="sidebar" :details="details" @closeSidebar="closeSidebar" />
      <div class="flex">
        <pt-pagination
          :total-rows="approvalCount"
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[10, 15, 20]"
          class="mt-8 mb-16"
          @page-changed="pageLimitHandler"
        />
      </div>
    </div>
    <p v-else class="p-10 text-center">No Data Found</p>
  </div>
</template>

<script>
import apiRequest from '@src/utils/apiRequest';
import { RESTO_MENU_APPROVALS } from '@src/config/apiEndpoints';
import { APPROVAL_STATUS } from '@constants';
import { PtPagination } from '@pathao/ui-components/esm/Pagination';
import ApprovalItem from '@src/components/menu/ApprovalItem';
import ApprovalChanges from '@src/components/menu/ApprovalChanges';

export default {
  name: 'MenuPendingList',
  page: {
    title: 'MenuPendingList',
  },
  components: {
    PtPagination,
    ApprovalItem,
    ApprovalChanges,
  },
  props: {
    filterType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      approvalList: [],
      details: null,
      isLoading: false,
      approvalCount: 10,
      currentPage: 1,
      pageSize: 10,
    };
  },
  watch: {
    async filterType() {
      await this.fetchApprovalList();
    },
  },
  async mounted() {
    await this.fetchApprovalList();
  },
  methods: {
    showDetail(details) {
      this.details = details;
      this.$refs.sidebar.toggle();
    },
    closeSidebar() {
      this.details = null;
      this.$refs.sidebar.toggle();
    },
    async fetchApprovalList(page = 1, pageSize = 10) {
      try {
        this.isLoading = true;
        const response = await apiRequest({
          url: RESTO_MENU_APPROVALS,
          method: 'GET',
          params: {
            menu_type: this.filterType.value,
            status: APPROVAL_STATUS.PENDING,
            page,
            page_size: pageSize,
          },
        });
        this.approvalList = response.data.data;
        this.approvalCount = response.data.count;
      } catch (error) {
        this.$notification.error('Failed to fetch Approval list');
      } finally {
        this.isLoading = false;
      }
    },
    pageLimitHandler(page, pageSize) {
      this.currentPage = page;
      this.pageSize = pageSize;
      this.fetchApprovalList(page, pageSize);
    },
  },
};
</script>
